/* BD21 tracking v1.1, 2026-09-24. Alt: new callback sources missed GTM callback_click. Neu: accepted callback component plus original source_component in the same push. Grund: full click coverage, no new event or duplicate conversion. */
(function() {
  window.dataLayer = window.dataLayer || [];

  function pushEvent(el) {
    var name = el.getAttribute('data-bd21-event');
    if (!name) return;
    var component = el.getAttribute('data-bd21-component') || '';
    var callback = name === 'beamdeals_offer_cta_click' && el.hasAttribute('data-bd-callback-open');
    var product = el.getAttribute('data-product-handle') || '';
    if (callback && !product) {
      var current = window.location.pathname.match(/^\/products\/([a-z0-9][a-z0-9-]{0,179})\/?$/);
      if (current) product = current[1];
    }
    var payload = {
      event: name,
      component: component,
      cta_label: (el.textContent || '').trim(),
      product_handle: product,
      page_type: el.getAttribute('data-page-type') || ''
    };
    if (callback) {
      // GTM v138 maps these existing components to callback_click. Preserve the
      // actual UI location separately; do not push callback_click a second time.
      payload.source_component = component;
      var accepted = ['callback', 'callback_header', 'callback_header_mobile', 'callback_badge', 'mobile_sticky'];
      payload.component = accepted.indexOf(component) !== -1 ? component : (component === 'header_nav' ? 'callback_header' : 'callback');
      var topic = (el.getAttribute('data-bd-callback-topic') || '').toLowerCase();
      if (['mietkauf', 'leasing', 'finanzierung'].indexOf(topic) !== -1) payload.finance_topic = topic;
    }
    window.dataLayer.push(payload);
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-bd21-event]');
    if (el) pushEvent(el);
  }, true);
})();
